import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { getStyles } from "@/helpers/getStyles"
import { IModalStoneFlexContainer, ModalStoneFrame } from "."
import styles from "./ModalStoneFlexContainer.module.scss"

export const ModalStoneFlexContainer: FC<
  PropsWithChildren<IModalStoneFlexContainer>
> = ({
  children,

  styles: stylesProp,
  outside,
  content,

  className,
  ...props
}) => {
  return (
    <div
      className={clsx(
        styles.ModalStoneFlexContainer,
        className,
        getStyles(stylesProp, styles)
      )}
      {...props}
    >
      {outside}
      <ModalStoneFrame />
      <div
        {...content}
        id="modal-stone-flex-container-content"
        className={clsx(
          styles.ModalStoneFlexContainer_content,
          content?.className
        )}
      >
        {children}
      </div>
    </div>
  )
}
